var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkipicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 18,
    fill: "white",
    stroke: "#DB004F",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04195 23.4713C7.01324 23.7575 7.24257 24 7.53024 24H9.78876C10.0493 24 10.2646 23.7996 10.2983 23.5412C10.5629 21.5082 11.4766 19.7929 13.0396 18.3952C14.7187 16.8937 16.7319 16.1429 19.0792 16.1429C20.5958 16.1429 22.1486 16.5619 23.7375 17.4C25.041 18.0875 26.15 18.9866 27.0646 20.0971C27.3207 20.4081 27.0884 20.8571 26.6855 20.8571H23.3708C23.0947 20.8571 22.8708 21.081 22.8708 21.3571V23.5C22.8708 23.7761 23.0947 24 23.3708 24H32.5C32.7761 24 33 23.7761 33 23.5V14.7048C33 14.4286 32.7761 14.2048 32.5 14.2048H30.25C29.9739 14.2048 29.75 14.4286 29.75 14.7048V17.139C29.75 17.6264 29.0989 17.8434 28.7762 17.4782C27.6394 16.1918 26.3209 15.1792 24.8208 14.4405C22.8708 13.4802 20.9569 13 19.0792 13C15.7931 13 13.0035 14.0651 10.7104 16.1952C8.55004 18.2021 7.32722 20.6275 7.04195 23.4713Z",
    fill: "#DB004F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipicon);
export default __webpack_public_path__ + "static/media/skipicon.364851a22ca51cdc6ea8e5189489170b.svg";
export { ForwardRef as ReactComponent };